import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HELP } from "@/lib/help";
import { serializeJsonLd } from "@/components/SEOHead";

const faqs = [
  {
    question: "How will a faster website actually help my business?",
    answer: "Speed directly impacts your bottom line. Studies show that every 100ms delay in load time can decrease conversion rates by 7%. A faster site means better user experience, higher search rankings, and more customers completing their purchases or inquiries.",
  },
  {
    question: "Do I need to understand the technical details?",
    answer: "Not at all. We handle all the technical complexity so you can focus on running your business. You'll receive a fast, beautiful website with simple documentation for any updates you need to make.",
  },
  {
    question: "How quickly can you build and launch my new website?",
    answer: "Most projects launch within 3-7 business days. We move fast without sacrificing quality. Complex e-commerce or custom functionality may take slightly longer, but we'll give you an accurate timeline during our discovery call.",
  },
  {
    question: "Will my website continue to perform well as my business grows?",
    answer: "Absolutely. We build with scalability in mind from day one. Our architecture handles traffic spikes gracefully, and our optional maintenance plans ensure your site stays optimized as you add content and features.",
  },
  {
    question: "What stack do you use?",
    answer: "We use modern, battle-tested technologies like React, Next.js, and Tailwind CSS. For content management, we often recommend headless CMS solutions like Sanity or Contentful. Everything is optimized for performance and developer experience.",
  },
];

const FAQSection = () => {
  return (
    <section className="py-16 border-t border-border" aria-labelledby="faq-title">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: serializeJsonLd({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map(({ question, answer }) => ({
              "@type": "Question", name: question,
              acceptedAnswer: { "@type": "Answer", text: answer },
            })),
          }),
        }}
      />
      <div className="container px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto">
        <h2 id="faq-title" className="text-2xl md:text-3xl font-bold mb-8 text-center">
          Frequently Asked Questions
        </h2>
        <Accordion type="single" collapsible className="w-full space-y-3">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-secondary/50 border border-border ring-1 ring-white/[0.08] dark:ring-white/[0.12] rounded-lg px-6 data-[state=open]:bg-secondary/70"
            >
              <AccordionTrigger className="text-left text-base md:text-lg font-medium hover:no-underline py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
        <p className="text-sm text-muted-foreground text-center mt-8">
          Didn't find what you're looking for?{" "}
          <a
            href={HELP.knowledgeBase}
            target="_blank"
            rel="noopener noreferrer"
            className="text-foreground underline hover:text-primary transition-colors"
          >
            Browse the full Knowledge Base →
          </a>
        </p>
      </div>
    </section>
  );
};

export default FAQSection;
